import React, { useContext } from "react";
import "./GlobalHeader.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import { ShopContext } from "../../context/shopContext";
import { StorefrontContext } from "../../context/storefrontContext";
import { Cart } from "../Cart";
import { CartStorefront } from "../Cart/CartStorefront";
import { useNavigate } from "react-router-dom";

export const GlobalHeader = (props) => {
  const { openCart: openOldCart } = useContext(ShopContext);
  const { openCart: openNewCart } = useContext(StorefrontContext);
  const history = useNavigate();

  // Use the new Storefront Cart by default
  const useStorefrontCart = true;

  return (
    <div className="header">
      <div className="logo">
        <div className="logoText" onClick={() => history("/")}>
          RcDepron
        </div>
        <div className="tagline">The Depron King: The US Source for Depron</div>
      </div>
      {/*end of logo*/}
      <div className="shoppingCartNavButtonWrapper">
        <div
          className="shoppingCartNavButton"
          onClick={() => {
            console.log(
              "Cart button clicked, useStorefrontCart:",
              useStorefrontCart
            );
            useStorefrontCart ? openNewCart() : openOldCart();
          }}
        >
          <FontAwesomeIcon icon={faShoppingCart} size="2x" />
          <span className="yourCart">Cart</span>
        </div>
      </div>
      {/*end of shoppingCartNavButton*/}
      {useStorefrontCart ? <CartStorefront /> : <Cart />}
    </div>
  );
};

export default GlobalHeader;
